var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 350,
    viewBox: "0 0 438 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_1181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.153 127.26C229.991 127.45 202.45 126.184 176.678 118.97C150.906 111.819 128.103 98.2768 107.384 82.4563C93.803 72.2046 81.4854 63.978 63.8618 65.2436C46.6173 66.1296 30.1938 72.5843 16.8656 83.5954C-5.49552 103.276 -2.0845 139.6 6.88522 165.166C20.3398 203.641 61.3352 230.409 96.1402 247.812C136.378 267.936 180.594 279.643 224.875 286.351C263.722 292.236 313.624 296.539 347.229 271.163C378.118 247.812 386.645 194.529 379.065 158.521C377.233 147.89 371.548 138.271 363.147 131.563C341.418 115.679 309.076 126.247 284.631 126.817C275.787 127.007 266.375 127.197 257.153 127.26Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.881 1.39221V15.3142",
    stroke: "#CFCFCF",
    strokeWidth: 5.21352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.87 8.35327H131.766",
    stroke: "#CFCFCF",
    strokeWidth: 5.21352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.982 279.39V293.312",
    stroke: "#CFCFCF",
    strokeWidth: 5.21352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.034 286.351H395.931",
    stroke: "#CFCFCF",
    strokeWidth: 5.21352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6449 219.145C21.4136 219.145 22.8033 217.753 22.8033 215.981C22.8033 214.209 21.4136 212.817 19.6449 212.817C17.8762 212.817 16.4866 214.209 16.4866 215.981C16.4866 217.69 17.9394 219.145 19.6449 219.145Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.81 15.7573C291.579 15.7573 292.969 14.3651 292.969 12.5932C292.969 10.8213 291.516 9.42908 289.81 9.42908C288.042 9.42908 286.652 10.8213 286.652 12.5932C286.652 14.3651 288.042 15.7573 289.81 15.7573Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.882 349.443C267.512 349.443 320.699 346.152 320.699 342.039C320.699 337.925 267.512 334.635 201.882 334.635C136.251 334.635 83.0646 337.925 83.0646 342.039C83.0646 346.089 136.251 349.443 201.882 349.443Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.353 39.2347H282.925C287.22 39.2347 291.326 40.9434 294.358 43.9809C297.39 47.0184 299.096 51.1317 299.096 55.4349V261.101C299.096 265.404 297.39 269.518 294.358 272.555C291.326 275.593 287.22 277.301 282.925 277.301H88.2442C83.9489 277.301 79.843 275.593 76.811 272.555C73.779 269.518 72.0735 265.404 72.0735 261.101V78.0265L110.353 39.2347Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 6.13356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.338 139.473H120.396V279.326H298.338V139.473Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0735 78.0265H103.467C105.299 78.0265 107.068 77.2672 108.395 76.0015C109.721 74.6726 110.416 72.9007 110.416 71.0655V39.2347L72.0735 78.0265Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 6.13356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.454 94.7963H121.47C114.648 94.7963 109.09 100.365 109.09 107.2V144.916C109.09 151.75 114.648 157.319 121.47 157.319H297.454C304.276 157.319 309.834 151.75 309.834 144.916V107.2C309.834 100.365 304.276 94.7963 297.454 94.7963Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 6.13356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.263 137.005C149.264 137.005 154.064 132.133 154.064 126.184C154.064 120.172 149.2 115.363 143.263 115.363C137.262 115.363 132.461 120.236 132.461 126.184C132.461 132.196 137.262 137.005 143.263 137.005Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.247 137.005C183.247 137.005 188.048 132.133 188.048 126.184C188.048 120.172 183.184 115.363 177.247 115.363C171.246 115.363 166.445 120.236 166.445 126.184C166.445 132.196 171.246 137.005 177.247 137.005Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.23 137.005C217.231 137.005 222.032 132.133 222.032 126.184C222.032 120.172 217.168 115.363 211.23 115.363C205.23 115.363 200.429 120.236 200.429 126.184C200.366 132.196 205.23 137.005 211.23 137.005Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.454 164.153H121.47C114.648 164.153 109.09 169.722 109.09 176.556V214.272C109.09 221.107 114.648 226.676 121.47 226.676H297.454C304.276 226.676 309.834 221.107 309.834 214.272V176.556C309.834 169.722 304.276 164.153 297.454 164.153Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 6.13356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.263 206.426C149.264 206.426 154.064 201.553 154.064 195.604C154.064 189.593 149.2 184.783 143.263 184.783C137.262 184.783 132.461 189.656 132.461 195.604C132.461 201.553 137.262 206.426 143.263 206.426Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.247 206.426C183.247 206.426 188.048 201.553 188.048 195.604C188.048 189.593 183.184 184.783 177.247 184.783C171.246 184.783 166.445 189.656 166.445 195.604C166.445 201.553 171.246 206.426 177.247 206.426Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.23 206.426C217.231 206.426 222.032 201.553 222.032 195.604C222.032 189.593 217.168 184.783 211.23 184.783C205.23 184.783 200.429 189.656 200.429 195.604C200.366 201.553 205.23 206.426 211.23 206.426Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.454 233.51H121.47C114.648 233.51 109.09 239.079 109.09 245.913V283.629C109.09 290.464 114.648 296.033 121.47 296.033H297.454C304.276 296.033 309.834 290.464 309.834 283.629V245.913C309.834 239.079 304.276 233.51 297.454 233.51Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 6.13356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.263 275.719C149.264 275.719 154.064 270.846 154.064 264.898C154.064 258.886 149.2 254.077 143.263 254.077C137.262 254.077 132.461 258.949 132.461 264.898C132.461 270.91 137.262 275.719 143.263 275.719Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.247 275.719C183.247 275.719 188.048 270.846 188.048 264.898C188.048 258.886 183.184 254.077 177.247 254.077C171.246 254.077 166.445 258.949 166.445 264.898C166.445 270.91 171.246 275.719 177.247 275.719Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.23 275.719C217.231 275.719 222.032 270.846 222.032 264.898C222.032 258.886 217.168 254.077 211.23 254.077C205.23 254.077 200.429 258.949 200.429 264.898C200.366 270.91 205.23 275.719 211.23 275.719Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.372 173.835C350.451 173.835 380.455 143.713 380.455 106.63C380.455 69.5468 350.451 39.3613 313.372 39.3613C276.293 39.3613 246.288 69.4835 246.288 106.567C246.288 143.65 276.293 173.835 313.372 173.835Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 6.13356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.063 155.357L378.939 173.266",
    stroke: "#BABABA",
    strokeWidth: 6.13356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.917 164.596L371.359 170.418C368.832 173.013 368.958 177.189 371.548 179.657L419.745 225.853C422.334 228.384 426.504 228.258 428.967 225.663L434.526 219.841C437.052 217.247 436.926 213.07 434.336 210.602L386.14 164.406C383.55 161.875 379.381 162.002 376.917 164.596Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 6.13356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_1181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 438,
    height: 349.443,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFile);
export default __webpack_public_path__ + "static/media/emptyFile.3a1e2176be51f93652d634c0a265b692.svg";
export { ForwardRef as ReactComponent };